<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>公司类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width: 150px" placeholder="请选择公司类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>公司名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width: 150px" placeholder="请输入公司名称" />
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width: 150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>抵扣编号：</p>
        <el-input v-model="deductionNum" size="mini" style="width: 150px" placeholder="请输入抵扣编号" />
      </div>
      <div class="navContainer" style="width: 400px">
        <p>费用时间：</p>
        <el-date-picker
          v-model='costDate'
          type='daterange'
          range-separator='-'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          style='width: 220px;'
          start-placeholder='开始日期'
          end-placeholder='结束日期' size='mini'>
        </el-date-picker>
        <el-date-picker v-if="false" v-model="startTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="date" placeholder="开始日期" />
        <span v-if="false" style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-if="false" v-model="endTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer" style="width: 280px">
        <p>是否生成对账单：</p>
        <el-select v-model="isStatement" filterable size="mini" style="width: 150px">
          <el-option v-for="item in isOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input v-model="createBy" size="mini" style="width: 150px" placeholder="请输入录入人员" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>结算人员：</p>
        <el-input v-model="settlementPersonnel" size="mini" style="width: 150px" placeholder="请输入结算人员" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>台账月：</p>
        <el-input v-model="standingBookMonth" size="mini" style="width: 150px" placeholder="请输入台账月" />
      </div>
      <div class="navContainer" style="width: 250px">
        <p>对账单编号：</p>
        <el-input v-model="settNo" size="mini" style="width: 150px" placeholder="请输入对账单编号" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtni">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">添加</el-button>
        <el-button size="small" type="primary" @click="generateStatementOfAccount">生成对账单</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainerNav" style="width: 100%; display: flex; justify-content: right;">
        <span class="el-icon-download el-icon--right" style="cursor: pointer; font-size: 16px; margin-right: 20px; color: rgba(51, 136, 255, 1); display: flex; align-items: center" @click="downloadTemplate">模板下载</span>
        <span @click="onClickExportData" style="cursor: pointer; font-size: 16px; color: rgba(51, 136, 255, 1);">导出数据</span>
        <span style="cursor: pointer; margin-left: 10px;">
          <el-upload ref="upload" class="upload-demo" :action="importUrl" :auto-upload="true" :show-file-list="false" :data="uploadData1" :on-success="planOnSuccess" :before-upload="beforeUpload">
            <i class="el-icon-upload el-icon--right" style="color: rgba(51, 136, 255, 1);">批量导入</i>
          </el-upload>
        </span>
      </div>
      <div class="tableContainer">
        <el-table
          ref="multipleTable"
          v-loading="tableLoad"
          :data="TableDatas"
          @select="handleCurrentChange1"
          tooltip-effect="dark"
          @select-all="handleCurrentChangeAll"
          :reserve-selection="true"
          :row-style="rowStyle"
          :row-key="
            row => {
              return row.id;
            }
          "
          style="width: 100%"
          border
          :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="deductionNum" label="抵扣编号" align="center" show-overflow-tooltip />
          <el-table-column prop="companyType" label="公司类型" align="center">
            <template slot-scope="scope">{{ scope.row.companyType | getCompanyType }}</template>
          </el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center" width="150" show-overflow-tooltip />
          <el-table-column prop="discountAmount" label="抵扣金额" align="center" />
          <el-table-column prop="remainingDiscountAmount" label="剩余抵扣金额" align="center" />
          <el-table-column prop="instruction" label="说明" align="center" max-width="150" show-overflow-tooltip />
          <el-table-column prop="createdTime" label="添加时间" align="center" show-overflow-tooltip />
          <el-table-column prop="auditType" label="状态" align="center">
            <template slot-scope="scope">{{ scope.row.auditType == 1 ? '待审核' : scope.row.auditType == 2 ? '已通过' : scope.row.auditType == 3 ? '已拒绝' : scope.row.auditType == 4 ? '已取消' : '-'}}</template>
          </el-table-column>
          <el-table-column prop="costTime" label="费用时间" align="center" />
          <el-table-column prop="createBy" label="录入人员" align="center" />
          <el-table-column prop="settlementPersonnel" label="结算人员" align="center" />
          <el-table-column prop="standingBookMonth" label="台账月" align="center" />
          <el-table-column label="是否生成对账单" align="center" width="110">
            <template slot-scope="scope">{{ scope.row.isStatement == 1 ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="settNo" label="对账单编号" align="center" />
          <el-table-column label="操作" width="330" align="center">
            <template slot-scope="scope">
              <div style="margin: 10px 0;">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)" style="margin-bottom: 10px;">详情</el-button>
                <el-button v-if="scope.row.auditType == 1 || scope.row.auditType == 3" size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button v-if="scope.row.auditType == 1" size="mini" type="info" @click="cancelClick(scope.row)">取消审核</el-button>
                <el-button v-if="scope.row.auditType == 4" size="mini" type="primary" @click="againClick(scope.row)">重新提交</el-button>
                <el-button size="mini" type="primary" @click="editLedgerMonthClick(scope.row)">
                  {{ scope.row.standingBookMonth ? '修改台账月' : '添加台账月' }}
                </el-button>
                <el-button size="mini" type="primary" @click="editSPClick(scope.row)">修改结算人员</el-button>
                <el-button v-if="scope.row.auditType == 4 || scope.row.auditType == 3" size="mini" type="danger" @click="disableClick(scope.row.id)">删除</el-button>
                <el-button size="mini" type="primary" @click="revokeDeductionOfExpenses(scope.row)" style="margin-bottom: 10px;">撤销抵扣费用</el-button>
                <el-button v-if="scope.row.isStatement === 0" size="mini" type="primary" @click="referClick(scope.row)">提交对账 </el-button>
                <el-button v-if="scope.row.isStatement === 1" size="mini" type="primary" @click="cancelReferClick(scope.row.id)">取消对账 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="650px" center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">抵扣编号：</span>
              <span>{{ detailData.deductionNum }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">公司类型：</span>
                <span>{{ detailData.companyType | getCompanyType }}</span>
              </div>
              <div>
                <span class="span1">公司名称：</span>
                <span>{{ detailData.companyName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">抵扣金额：</span>
                <span>{{ detailData.discountAmount }}</span>
              </div>
              <div>
                <span class="span1">剩余抵扣金额：</span>
                <span>{{ detailData.remainingDiscountAmount }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">说明：</span>
              <span>{{ detailData.instruction }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">添加时间：</span>
              <span>{{ detailData.createdTime }}</span>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>抵扣对账单</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">编号：</span>
                <span>{{ detailData.reconciliationSettlementInfo ? detailData.reconciliationSettlementInfo['settNo'] : '' }}</span>
              </div>
              <div>
                <span class="span1">标题：</span>
                <span>{{ detailData.reconciliationSettlementInfo ? detailData.reconciliationSettlementInfo['title'] : '' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div>
                <span class="span1">抵扣金额：</span>
                <span>{{ detailData.reconciliationSettlementInfo ? detailData.reconciliationSettlementInfo['taxPrice'] : '' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation" v-if="false">
          <div class="operationTitle">
            <div class="line" />
            <span>抵扣对账单</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operationData2" border>
              <el-table-column label="序号" align="center" width="50px" type="index" />
              <el-table-column prop="settNo" label="编号" align="center" />
              <el-table-column prop="title" label="标题" align="center" />
              <el-table-column prop="createTime" label="抵扣时间" align="center" />
              <el-table-column prop="taxPrice" label="抵扣金额" align="center" />
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作记录</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ scope.row.createTime }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px" center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息">
            <el-form-item label="公司类型：" prop="companyTypeId" style="margin-top: 20px">
              <el-radio-group v-model="companyData.companyTypeId" @change="companyTypeChange" value-key="companyTypeName">
                <el-radio v-for="(item, index) in companyTypeList" :label="item.companyTypeId" :key="`${index}tr`">{{ item.companyTypeName }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="公司名称：" prop="name">
              <el-select v-model="companyData.name" filterable placeholder="请选择委托商" size="mini" value-key="id" style="width: 90%">
                <el-option v-for="(item, index) in companyList" :label="item.name" :value="item" :key="`${index}sds`"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="抵扣金额：" prop="price" style="margin-bottom: 15px">
              <el-input style="width: 90%" v-model="companyData.price" autocomplete="off" placeholder="请输入抵扣金额" size="mini" />
            </el-form-item>
            <el-form-item label="说明：" prop="remark" style="margin-bottom: 20px">
              <el-input style="width: 90%" v-model="companyData.remark" autocomplete="off" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入说明" size="mini" />
            </el-form-item>
            <el-form-item label="费用时间：" prop="costTime">
              <el-date-picker v-model="companyData.costTime" type="datetime" size="mini" style="width: 90%" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="录入人员：" prop="createBy" style="margin-bottom: 15px" v-if="false">
              <el-input style="width: 90%" v-model="companyData.createBy" autocomplete="off" placeholder="请输入录入人员" size="mini" />
            </el-form-item>
            <el-form-item label="结算人员：" prop="settlementPersonnel" style="margin-bottom: 15px">
              <el-input style="width: 90%" v-model="companyData.settlementPersonnel" autocomplete="off" placeholder="请输入结算人员" size="mini" />
            </el-form-item>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick(companyData)">确认</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :title="importShow ? '导入生成对账单' : '生成对账单'" :visible.sync="dialogElseVisible" width="950px" center @close="dialogElseClose">
      <else-Add-account :check-table-data="JSON.parse(JSON.stringify(checkTableData))" :import-show="importShow" @selectionTable="selectChange" :initType="'discount'" ref="accountState">
        <template slot="label">基础信息</template>
      </else-Add-account>
    </el-dialog>
    <el-dialog :title="dialogLedgerTitle" :visible.sync="ledgerVisible" width="400px" center @close="ledgerClose">
      <div class="leader-input">
        <span>请输入台账月：</span>
        <el-date-picker v-model="standingBookMonthi" size="mini" value-format="yyyy-MM" type="month" placeholder="请选择台账月" />
        <div style="display: inline-block; width: calc(100% - 130px); text-align: right; margin-top: 10px">
          <el-button size="small" class="searchBtn" @click="dialogSubmit(id)">确 定</el-button>
          <el-button size="small" class="resetBtn" @click="dialogMouthClose">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改结算人员" :visible.sync="dialogFormVisibleEditSP" width="400px" center @close="editSPClose">
      <div class="leader-input">
        <span>结算人员：</span>
        <el-input v-model="formEditSP.settlementPersonnel" size="mini" autocomplete="off" style="width: 80%"></el-input>
        <div style="display: inline-block; width: calc(100% - 130px); text-align: right; margin-top: 10px">
          <el-button size="small" class="searchBtn" @click="dialogSubmitSP" :loading="dialogSubmitSPLoading">确 定</el-button>
          <el-button size="small" class="resetBtn" @click="dialogFormVisibleEditSP = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  提交对账  -->
    <el-dialog :title="dialogBillTitle" :visible.sync="billDialogVisible" center @before-close="dialogBillClose" :close-on-click-modal="false">
      <div class="nav">
        <div class="navContainer">
          <p style="width: 120px; display: inline-block; text-align: right">对账单编号：</p>
          <el-input v-model="billData.settNo" size="mini" style="width: 160px" placeholder="请输入对账单编号" />
        </div>
        <div class="navContainer">
          <p style="width: 60px; display: inline-block; text-align: right">标题：</p>
          <el-input v-model="billData.title" size="mini" style="width: 120px" placeholder="请输入标题" />
        </div>
        <div class="navBtn" style="display: flex; justify-content: flex-end">
          <el-button size="small" class="searchBtn" @click="billSearchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="billResetBtn">重置</el-button>
          <el-button size="small" class="submit" @click="submit">确认</el-button>
        </div>
      </div>
      <div class="tableContent">
        <el-table ref="billRef" :data="billTable.table" v-loading="billTableLoad" style="width: 100%" border :header-cell-style="headerCellStyle" highlight-current-row @current-change="handleCurrentChange">
          <el-table-column align="center" width="50px">
            <template v-slot="{ row, $index }">
              <el-radio v-model="radioId" :label="row.id" @change="val => handleChange(val, row.id)">&nbsp; </el-radio>
            </template>
          </el-table-column>
          <el-table-column property="settNo" align="center" label="对账单编号" width="139"></el-table-column>
          <el-table-column property="title" align="center" label="标题" width="130"></el-table-column>
          <el-table-column property="companyNameNew" align="center" label="公司" width="140"></el-table-column>
          <el-table-column label="合计含税费用" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <div>
                <span v-if="scope.row.settType === 1">{{ scope.row.taxPrice }}</span>
                <span v-else-if="scope.row.settType === 2">{{ scope.row.taxSettPrice }}</span>
                <span v-else>{{ scope.row.taxPrice != null && scope.row.taxPrice > 0 ? scope.row.taxPrice : scope.row.taxSettPrice }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="合计不含税费用" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <div>
                <span v-if="scope.row.settType === 1">{{ scope.row.noTaxPrice }}</span>
                <span v-else>{{ scope.row.noTaxSettPrice }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 10px">
        <span>共{{ billDataTotal }}条</span>
        <el-pagination :page-sizes="[100, 200, 300, 400]" :page-size="100" layout=" sizes, prev, pager, next, jumper" :total="billDataTotal" @size-change="billSizeChange" @current-change="billCurrentChange" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import elseAddAccount from '@/views/settle/else/components/elseAddAccount.vue';
  import accountState from '@/views/settle/supplier/components/accountState.vue';
  import {
    discountPagination,
    newInvoice,
    invoicingDelete,
    invoicingModification,
    viewDetails,
    cancelDiscount,
    againDiscount,
    updateStandingBookMonth,
    updatePersonneli,
    cancelDiscounExpenses,
    getReconciliation, SubmitReconciliation, cancelSubmit,
  } from '@/service/contract';
  import { highwayLineSelectList, highwayLineSelectWaterSupplier } from '@/service/financial';
  import { supplierListSelectPort } from '@/service/vehiclelog';
  import { customerInfoSelectList } from '@/service/getData';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
      elseAddAccount,
      accountState,
    },
    data() {
      return {
        costDate: ['', ''],
        ids: '',
        type: '',
        nameIpt: '',
        stateIpt: '',
        deductionNum: '', // 抵扣编号
        startTime: '', // 费用时间 开始
        endTime: '', // 费用时间 结束
        isStatement: '', // 是否生成对账单
        createBy: '', // 录入人员
        settlementPersonnel: '', // 结算人员
        standingBookMonth: '', // 台账月
        standingBookMonthi: '',
        settNo: '', // 对账单编号
        typeIpt: '',
        dialogElseVisible: false,
        importShow: false,
        stateOption: [
          { value: '', label: '全部' },
          { value: 1, label: '待审核' },
          { value: 2, label: '已通过' },
          { value: 3, label: '已拒绝' },
          { value: 4, label: '已取消' },
        ],
        typeOption: [
          { value: '', label: '全部' },
          { value: 0, label: '委托商' },
          { value: 1, label: '公路供应商' },
          { value: 2, label: '水路供应商' },
          { value: 3, label: '港口及其他' },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        // 详情
        detailDialogVisible: false,
        addLoad: false,
        detailData: {},

        nameOption: [
          { value: '123', label: '123' },
          { value: '222', label: '333' },
        ],
        // 新增/修改
        dialogTitle: '',
        dialogVisible: false,
        companyData: {
          id: '',
          name: '',
          companyTypeId: '', //公司类型
          warehouse: '',
          address: '',
          free: '',
          unit: 0,
          price: '',
          unit2: 0,
          costTime: '', // 费用时间
          createBy: '', // 录入人员
          settlementPersonnel: '', // 结算人员
        },
        companyList: [],
        unitOption: [
          { value: 1, label: '天' },
          { value: 2, label: '时' },
        ],
        companyTypeList: [
          { companyTypeId: 1, companyTypeName: '委托商' },
          { companyTypeId: 2, companyTypeName: '公路供应商' },
          { companyTypeId: 3, companyTypeName: '水路供应商' },
          { companyTypeId: 4, companyTypeName: '港口及其他' },
        ],
        companyTypeListMap: new Map(),
        rules: {
          name: [{ required: true, message: '请选择公司类型', trigger: 'blur' }],
          remark: [{ required: true, message: '请输入说明', trigger: 'blur' }],
          companyTypeId: [{ required: true, message: '请选择委托商', trigger: 'blur' }],
          type: [{ required: true, message: '请选择公司类型', trigger: 'blur' }],
          price: [{ required: true, message: '请输入抵扣金额', trigger: 'blur' }],
          costTime: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
          createBy: [{ required: true, message: '请输入录入人员', trigger: 'blur' }],
          settlementPersonnel: [{ required: true, message: '请输入结算人员', trigger: 'blur' }],
        },
        regionList: [],
        mapVisible: false,
        isOption: [
          { value: '', label: '全部' },
          { value: 1, label: '是' },
          { value: 0, label: '否' },
        ],
        checkTableData: [],
        ledgerVisible: false,
        dialogLedgerTitle: '修改台账月',
        settlement: '', // 生成对账单时的结算方式
        dialogFormVisibleEditSP: false,
        formEditSP: {
          settlementPersonnel: '',
          id: '',
        },
        dialogSubmitSPLoading: false,
        importUrl: '', //导入地址
        uploadData1: { mFile: '' },
        importLoading: false,
        //提交对账单
        dialogBillTitle: '选择对账单',
        billDialogVisible: false,
        billTableLoad: false,
        billDataTotal: 0,
        otherId: '',
        settlementId: '',
        title: '',
        currentRow: null,
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '90px',
          background: '#E8E8E8',
        },
        billData: {
          settNo: '',
          title: '',
          companyNameNew: '',
          companyName: '',
          settlementId: '', //行数据id
          page: 1,
          size: 10
        },
        billTable: {
          table: [],
          title: '',
        },
        radioId: '',
        billDataSelection: [], //对账单选择
      };
    },
    mounted() {
      this.companyTypeList.forEach(item => {
        this.companyTypeListMap.set(item.companyTypeName, item.companyTypeId);
      });
    },
    filters: {
      getCompanyType(val) {
        switch (val) {
          case 0:
            return '委托商';
          case 1:
            return '公路供应商';
          case 2:
            return '水路供应商';
          case 3:
            return '港口及其他';
        }
      },
    },
    created() {
      this.searchBtn();
      let token = getSessionStore('token');
      // this.importUrl = baseUrl + `/deductionInvoicingCost/import?access_token=${token}`;
      this.importUrl = getImportUrl('/deductionInvoicingCost/import');
    },
    methods: {
      async revokeDeductionOfExpenses(row) {
        const { status, message } = await cancelDiscounExpenses(row);
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.searchBtn();
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData1.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._customerInfoPageList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            // this.TableDatas = res.data;
            await this.searchBtn();
          },
        });
      },
      onClickExportData() {
        // let token = getSessionStore('token');
        let id = this.checkTableData.map(item => item.id).join(',');
        // window.location.href = `${baseUrl}/platform/deductionInvoicingCost/export?access_token=${token}&id=${id}&typeIpt=${this.typeIpt}&nameIpt=${this.nameIpt}&stateIpt=${this.stateIpt}&deductionNum=${this.deductionNum}&startTime=${this.startTime}&endTime=${this.endTime}&isStatement=${this.isStatement}&createBy=${this.createBy}&settlementPersonnel=${this.settlementPersonnel}&standingBookMonth=${this.standingBookMonth}&settNo=${this.settNo}`;
        window.exportExcelGet('/platform/deductionInvoicingCost/export', `id=${id}&typeIpt=${this.typeIpt}&nameIpt=${this.nameIpt}&stateIpt=${this.stateIpt}&deductionNum=${this.deductionNum}&startTime=${this.startTime}&endTime=${this.endTime}&isStatement=${this.isStatement}&createBy=${this.createBy}&settlementPersonnel=${this.settlementPersonnel}&standingBookMonth=${this.standingBookMonth}&settNo=${this.settNo}`)
      },
      downloadTemplate() {
        window.location.href = '/file/抵扣费用模板.xlsx';
      },
      editSPClick(row) {
        this.formEditSP.id = row.id;
        this.formEditSP.settlementPersonnel = row.settlementPersonnel;
        this.dialogFormVisibleEditSP = true;
      },
      dialogMouthCloseSP() {},
      async dialogSubmitSP() {
        this.dialogSubmitSPLoading = true;
        const res = await updatePersonneli(this.formEditSP);
        if (res.status != 0) {
          this.$message.error(res.message);
          this.dialogSubmitSPLoading = false;
        } else {
          this.$message.success(res.message);
          this.dialogSubmitSPLoading = false;
          this.searchBtn();
          this.dialogFormVisibleEditSP = false;
        }
      },
      editSPClose() {},
      async dialogSubmit() {
        const { status, message } = await updateStandingBookMonth({
          month: this.standingBookMonthi,
          id: this.settlement,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.searchBtn();
        this.dialogMouthClose();
      },
      dialogMouthClose() {
        this.ledgerVisible = false;
      },
      //关闭弹窗
      ledgerClose() {
        this.ledgerVisible = false;
      },
      editLedgerMonthClick(row) {
        console.log(row);
        this.ledgerVisible = true;
        if (row.standingBookMonth) {
          this.standingBookMonthi = row.standingBookMonth.slice(0, row.standingBookMonth.length - 2) + '-' + row.standingBookMonth.slice(row.standingBookMonth.length - 2, row.standingBookMonth.length);
        } else {
          this.standingBookMonthi = row.standingBookMonth;
        }
        this.settlement = row.id;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      dialogElseClose() {
        this.dialogElseVisible = false; //关闭窗口
      },
      dateChange(val) {
        if (this.endTime && this.startTime && this.compareDate(this.startTime, this.endTime)) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      generateStatementOfAccount() {
        console.log(this.checkTableData);
        if (this.checkTableData.length <= 0) return this.$message.warning('请至少选择一条结算数据！');
        let companyFlag = false; // 公司名称
        let taxFlag = false; // 税率
        let reconciliationFlag = false; // 是否生成对账单
        if (this.checkTableData.length > 0) {
          const { companyId, taxRate } = this.checkTableData[0];
          this.checkTableData.forEach(item => {
            if (item.companyId !== companyId) {
              companyFlag = true;
            }
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
            if (item.isStatement) {
              reconciliationFlag = true;
            }
          });
        }
        if (companyFlag) return this.$message.warning('只能选择同一家公司数据！');
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');
        if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');
        // 生成对账单弹窗显示
        this.dialogElseVisible = true;
        this.$nextTick(() => {
          this.$refs.accountState.$nextTick(() => {
            this.$refs.accountState.closeFormData();
            this.$refs.accountState.init1(this.checkTableData);
          });
          this.importShow = false;
        });
      },
      handleCurrentChange1(val) {
        this.checkTableData = val;
      },
      handleCurrentChangeAll(val) {
        this.checkTableData = val;
      },
      selectChange(val) {
        // 先清空选择
        this.$refs.multipleTable.clearSelection();
        // 将子组件表格数据赋值。
        this.checkTableData = val;
        this.$nextTick(() => {
          val.forEach(row => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选  重新勾选
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
          });
        });
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this.searchBtn();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.searchBtn();
      },
      // 是否确认删除
      disableClick(id) {
        this.$confirm('确定要删除当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            await this.invoicingDeletes(id);
          })
          .catch(() => {});
      },
      // 重新提交
      againClick(row) {
        this.$confirm('确定要重新提交当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await againDiscount(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      // 取消审核
      cancelClick(row) {
        this.$confirm('确认取消审核当前任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await cancelDiscount(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      //提交对账
      referClick(row) {
        this.billDialogVisible = true;
        this.billData.settlementId = row.id;
        this.billData.companyName = row.companyName;
        this.billSearch();
      },
      //确认
      async submit() {
        const settlementId = this.id;
        const deductId = this.billData.settlementId;
        this.$confirm(`确认选择该对账单？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await SubmitReconciliation(deductId, settlementId);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.dialogBillClose();
          await this.expensepaging();
        });
      },
      //取消对账
      cancelReferClick(id) {
        this.$confirm('确定要取消对账吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await cancelSubmit(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      handleChange(id, idx) {
        this.id = idx;
      },
      //单选
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      //对账查询
      async billSearch() {
        this.billTableLoad = true;
        let obj = {
          companyName: this.billData.companyName,
          settNo: this.billData.settNo,
          title: this.billData.title,
          page: 1,
          size: 10,
        };
        const res = await getReconciliation(obj);
        this.billTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.billTable.table = res.data.records;
        this.billDataTotal = res.data.total;
      },
      billSearchBtn() {
        this.billSearch();
      },
      //重置
      billResetBtn() {
        this.billData.settNo = '';
        this.billData.title = '';
      },
      //关闭对话框
      dialogBillClose() {
        this.billResetBtn();
        this.billDialogVisible = false;
        if (this.$refs.billRef) this.$refs.billRef.clearSelection();
      },
      billSizeChange(sizes) {
        this.billData.size = sizes;
      },
      billCurrentChange(page) {
        this.billData.page = page;
      },
      // 详情
      async detailClick(id) {
        this.detailDialogVisible = true;
        this.viewDetailses(id);
      },
      // 查看详情
      async viewDetailses(id) {
        const res = await viewDetails(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
      },
      // 修改
      changeClick(item) {
        console.log(item);
        this.dialogTitle = '修改抵扣费用';
        this.dialogVisible = true;
        this.type = '0';
        this.companyData.companyTypeId = parseInt(item.companyType) + 1; //公司类型
        this.companyData.name = item.companyName; //公司名称
        this.companyData.id = item.companyId; //公司名称
        this.companyData.price = item.discountAmount; //抵扣金额
        this.companyData.remark = item.instruction; //说明
        this.ids = item.id;
      },
      searchBtni() {
        this.page = 1;
        this.searchBtn();
      },
      // 查询
      searchBtn() {
        this.tableLoad = true;
        if(!this.costDate) {
          this.costDate = ['', '']
        }
        // this.page = 1;
        const data = {
          page: this.page,
          rows: this.size,
          companyType: this.typeIpt, //公司类型
          companyName: this.nameIpt, //公司名称
          auditType: this.stateIpt, //状态
          deductionNum: this.deductionNum, // 抵扣编号
          startTime: this.costDate[0], // 费用时间 开始
          endTime: this.costDate[1], // 费用时间 结束
          isStatement: this.isStatement, // 是否生成对账单
          createBy: this.createBy, // 录入人员
          settlementPersonnel: this.settlementPersonnel, // 结算人员
          standingBookMonth: this.standingBookMonth, // 台账月
          settNo: this.settNo, // 对账单编号
        };
        this.deductionInvoicingCost(data);
      },
      // 分页查询
      async deductionInvoicingCost(data) {
        const res = await discountPagination(data);
        if (res.status === 0) {
          this.TableDatas = res.data.records;
          // this.TableDatas.forEach(item => {
          //   if (item.auditType == 1) {
          //     item.auditType = '待审核';
          //   }
          //   if (item.auditType == 2) {
          //     item.auditType = '已通过';
          //   }
          //   if (item.auditType == 3) {
          //     item.auditType = '已拒绝';
          //   }
          //   if (item.auditType == 4) {
          //     item.auditType = '已取消';
          //   }
          // });
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
        this.tableLoad = false;
      },
      // 删除发票
      async invoicingDeletes(id) {
        const res = await invoicingDelete(id);
        if (res.status == 0) {
          this.$message.success(res.message);
          this.searchBtn();
        } else {
          this.$message.error(res.message);
        }
      },
      // 重置
      resetBtn() {
        this.nameIpt = '';
        this.stateIpt = '';
        this.typeIpt = '';
        this.deductionNum = '';
        this.startTime = '';
        this.endTime = '';
        this.isStatement = '';
        this.createBy = '';
        this.settlementPersonnel = '';
        this.standingBookMonth = '';
        this.settNo = '';
      },
      // 新增
      addBtn() {
        this.dialogTitle = '添加抵扣费用';
        this.dialogVisible = true;
        this.companyData = {};
        this.type = '1';
      },
      // 公司类型改变
      async companyTypeChange(value) {
        if (this.companyData.name) {
          this.companyData.name = '';
        }
        //签约单位类型  2 公路 3 水路 4 港口
        switch (value) {
          // switch (this.companyTypeListMap.get(value)) {
          case 1:
            await this._customerInfoSelectList();
            break;
          case 2:
            await this._highwayLineSelectList();
            break;
          case 3:
            await this._highwayLineSelectWaterSupplier();
            break;
          case 4:
            await this._shipDeployPublicSelectPort();
            break;
        }
      },
      // 委托商 -- 公司名称
      async _customerInfoSelectList() {
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) return this.$message.error(res3.message);
        this.companyList = res3.data.map(item => {
          return {
            name: item.customer_name,
            id: item.id,
          };
        });
      },
      // 公路供应商 -- 公司名称
      async _highwayLineSelectList() {
        let res = await highwayLineSelectList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data.map(item => {
          return {
            name: item.name,
            id: item.id,
          };
        });
      },
      // 水路供应商 -- 公司名称
      async _highwayLineSelectWaterSupplier() {
        let res = await highwayLineSelectWaterSupplier();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data;
      },
      // 港口及其他 -- 公司名称
      async _shipDeployPublicSelectPort() {
        let res = await supplierListSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyList = res.data.map(item => {
          return {
            name: item.supplier_name,
            id: item.id,
          };
        });
      },
      // 新增/修改 -- 确认
      addClick(llt) {
        //type等于1为新增，type等于0为修改
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.addLoad = true;

            //type等于1为新增，type等于0为修改
            if (this.type === '1') {
              const data = {
                companyType: this.companyData.companyTypeId - 1, //公司类型
                companyName: this.companyData.name.name, //公司名称
                companyId: this.companyData.name.id, //公司id
                discountAmount: this.companyData.price, //抵扣金额
                instruction: this.companyData.remark, //说明
                costTime: this.companyData.costTime, // 费用时间
                // createBy: this.createBy, // 录入人员
                settlementPersonnel: this.companyData.settlementPersonnel, // 结算人员
              };
              this.newsInvoice(data);
            }
            if (this.type === '0') {
              if (this.companyData.name.name !== undefined) {
                const data = {
                  id: this.ids,
                  companyType: this.companyData.companyTypeId - 1, //公司类型
                  companyName: this.companyData.name.name, //公司名称
                  companyId: this.companyData.name.id, //公司id
                  discountAmount: this.companyData.price, //抵扣金额
                  instruction: this.companyData.remark, //说明
                  costTime: this.companyData.costTime, // 费用时间
                  // createBy: this.createBy, // 录入人员
                  settlementPersonnel: this.companyData.settlementPersonnel, // 结算人员
                };
                this.invoicingModifications(data);
              } else {
                const data = {
                  id: this.ids,
                  companyType: this.companyData.companyTypeId - 1, //公司类型
                  companyName: this.companyData.name, //公司名称
                  companyId: this.companyData.id, //公司id
                  discountAmount: this.companyData.price, //抵扣金额
                  instruction: this.companyData.remark, //说明
                  costTime: this.companyData.costTime, // 费用时间
                  // createBy: this.createBy, // 录入人员
                  settlementPersonnel: this.companyData.settlementPersonnel, // 结算人员
                };
                this.invoicingModifications(data);
              }
            }
          } else return false;
        });
      },
      //  折扣开票 -- 新增
      async newsInvoice(data) {
        const res = await newInvoice(data);
        this.addLoad = false;
        if (res.status == 0) {
          this.$message.success(res.message);
          this.$refs.ruleForm.resetFields();
          this.dialogVisible = false;
          this.searchBtn();
        } else {
          this.$message.error(res.message);
        }
      },
      // 折扣开票 -- 修改
      async invoicingModifications(data) {
        const res = await invoicingModification(data);
        this.addLoad = false;
        if (res.status == 0) {
          this.$refs.ruleForm.resetFields();
          this.dialogVisible = false;
          this.$message.success(res.message);
          this.searchBtn();
        } else {
          this.$message.error(res.message);
        }
      },
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;
    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }
    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }
    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;
        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }
      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;
        ::v-deep {
          .el-table .cell {
            padding: 0;
          }
          .el-table th {
            padding: 0;
          }
          .el-table td {
            padding: 0;
          }
          .el-loading-mask {
            z-index: 1020;
          }
        }
      }
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span {
          font-size: 13px;
        }
      }
    }
    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo {
        display: flex;
        flex-direction: column;
        &Title {
          display: flex;
          align-items: flex-end;
          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          &Item {
            margin-bottom: 20px;
            .span1 {
              font-weight: 700;
            }
            span {
              font-size: 14px;
            }
            .specialOne {
              width: 50%;
            }
          }
          .specialItem {
            display: flex;
          }
        }
      }
      .operation {
        display: flex;
        flex-direction: column;
        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }
          .cell {
            font-size: 10px;
            padding: 0;
          }
        }
        &Title {
          display: flex;
          align-items: flex-end;
          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
    .company {
      width: 100%;
      padding: 20px 10px;
      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }
        .el-form-item__label {
          padding: 0;
        }
        .el-form-item__content {
          position: relative;
        }
        .el-form-item {
          margin-bottom: 10px;
        }
        .el-form-item__error {
          padding-top: 0;
          top: 97%;
        }
      }
      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        button {
          margin: 0 15px;
        }
      }
    }
    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }
  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }
    .el-dialog__headerbtn {
      top: 9px;
    }
    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }

  ::v-deep {
    .tableContainerNav span i.el-icon-upload.el-icon--right {
      font-size: 16px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-input--mini .el-input__inner {
      padding: 0 25px;
    }
  }
</style>
